/* eslint-disable camelcase */
import React from 'react';
import useUpdatePreview from '@lib/prismic/util/useUpdatePreviewRef';
import MainComponent from '@components/pages/GiftPage/GiftPage';
import Compose from '@components/shared/Compose';
import LoginRegisterModalProvider
  from '@components/shared/providers/LoginRegisterModalProvider/LoginRegisterModalProvider';
import ShareModalProvider from '@components/shared/providers/ShareModalProvider/ShareModalProvider';
import ExploreProductModalProvider
  from '@components/shared/providers/ExploreProductModalProvider/ExploreProductModalProvider';
import ThemeProvider from '@components/theme/ThemeProvider';
import { GetStaticProps } from 'next';
import getPrismicStaticProps from '@lib/prismic/getPrismicStaticProps';

interface GiftCardPageProps {
  data: any;
  previewRef: any;
  prismicDoc: any;
}

export default function GiftCardPage({ previewRef, prismicDoc, data }: GiftCardPageProps) {
  useUpdatePreview(previewRef, prismicDoc.id);
  return (
    <Compose
      components={[
        ThemeProvider,
        LoginRegisterModalProvider,
        ShareModalProvider,
        ExploreProductModalProvider
      ]}
    >
      <MainComponent prismicData={data} />
    </Compose>
  );
}

export const getStaticProps: GetStaticProps = getPrismicStaticProps({
  docType: 'gift_page',
  docUID: 'gift_page'
});
